import dayjs from 'dayjs'
import renderDatetime from '../../../../../../helpers/tables/render-datetime'
import Receipt, { ReceiptStatus } from '../../../../../../types/api/receipt'
import { EditingFormValues } from '../components/edit/types/editing-form-values'

export const status: ReceiptStatus[] = ['Создан', 'Прибыл', 'В приемке', 'Завершен', 'Отменен']

export default function getInitialValues(value?: Receipt): EditingFormValues {
    if (value)
        return {
            number: value.id,
            supplier: value.supplier?.documentId || '',
            receiptStatus: value.receiptStatus,
            createdAt: renderDatetime(value.createdAt),
            receiptSum: value.sum || 0,
            estimatedDate: value.estimatedDate ? dayjs(value.estimatedDate) : undefined,
        }
    return {} as EditingFormValues
}
